import { motion } from "framer-motion";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 },
  }),
};

export default function Contact() {
  return (
    <section
      id="kapcsolat"
      data-testid="contact-section"
      className="relative border-t border-white/5 bg-[#050A1A] px-6 sm:px-10 md:px-16 py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={0}
          className="flex items-center gap-3 mb-10"
        >
          <span className="h-px w-10 bg-blue-500/70" />
          <span className="text-[11px] sm:text-xs font-bold tracking-[0.32em] uppercase text-white/70 font-heading">
            Kapcsolat
          </span>
        </motion.div>

        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={1}
          data-testid="contact-heading"
          className="font-heading text-white font-light tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-7xl max-w-4xl leading-[1.05]"
        >
          Indítsuk el a{" "}
          <span className="italic font-serif text-blue-400">projektjét</span>.
        </motion.h2>

        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={2}
          className="mt-8 max-w-xl text-base sm:text-lg text-white/60 font-light leading-relaxed"
        >
          Akár új weboldalra van szüksége, akár a meglévőt szeretné újragondolni
          — beszéljünk róla. Válasz 24 órán belül.
        </motion.p>

        {/* Contact links */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
          <motion.a
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={3}
            href="mailto:pavellavince@gmail.com"
            data-testid="contact-email-link"
            className="group bg-[#030712] p-8 sm:p-12 flex flex-col gap-6 hover:bg-[#0A1229] transition-colors duration-500"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Mail
                  className="w-5 h-5 text-blue-400"
                  strokeWidth={1.5}
                />
                <span className="text-xs tracking-[0.3em] uppercase text-white/60 font-heading">
                  Email
                </span>
              </div>
              <ArrowUpRight
                className="w-5 h-5 text-white/40 group-hover:text-blue-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500"
                strokeWidth={1.5}
              />
            </div>
            <span
              className="font-heading font-light text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight break-all group-hover:text-blue-400 transition-colors duration-500"
              data-testid="contact-email-value"
            >
              pavellavince@gmail.com
            </span>
          </motion.a>

          <motion.a
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={4}
            href="tel:+36306638197"
            data-testid="contact-phone-link"
            className="group bg-[#030712] p-8 sm:p-12 flex flex-col gap-6 hover:bg-[#0A1229] transition-colors duration-500"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Phone
                  className="w-5 h-5 text-blue-400"
                  strokeWidth={1.5}
                />
                <span className="text-xs tracking-[0.3em] uppercase text-white/60 font-heading">
                  Telefon
                </span>
              </div>
              <ArrowUpRight
                className="w-5 h-5 text-white/40 group-hover:text-blue-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500"
                strokeWidth={1.5}
              />
            </div>
            <span
              className="font-heading font-light text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl tracking-tight group-hover:text-blue-400 transition-colors duration-500"
              data-testid="contact-phone-value"
            >
              06 30 663 8197
            </span>
          </motion.a>
        </div>

        {/* Footer line */}
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={5}
          className="mt-20 pt-8 border-t border-white/5 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between"
        >
          <span className="text-xs tracking-[0.3em] uppercase text-white/40 font-heading">
            © {new Date().getFullYear()} Webcraft — Pavel Lavince
          </span>
          <span className="text-xs tracking-[0.3em] uppercase text-white/40 font-heading">
            Készült Magyarországon
          </span>
        </motion.div>
      </div>
    </section>
  );
}
